import React, {Component} from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

import AccordionSection from './AccordionSection';

const styles = () => ({
    outerContainer: {
        marginBottom: 30,
        '& ul': {
            padding: 15,
            listStylePosition: 'inside'
        },
        '& li': {
            marginBottom: 8
        }
    }
});

class Accordion extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired
    };

    constructor(props) {
        super(props);

        const openSections = {};
        const {children = []} = this.props;

        React.Children.forEach(children, child => {
            const {isOpen, label} = child.props;

            if (isOpen) {
                openSections[label] = true;
            }
        });

        this.state = {openSections};
    }

    handleAccordionClick = label => {
        const {openSections} = this.state;
        const isOpen = !!openSections[label];

        this.setState({
            openSections: {
                [label]: !isOpen
            }
        });
    };

    render() {
        const {props, state} = this;
        const {children, classes} = props;
        const {openSections} = state;

        return (
            <div className={classes.outerContainer}>
                {React.Children.map(children, (child, i) => {
                    const {props} = child;
                    const {children: grandChildren, label} = props;

                    return (
                        <AccordionSection
                            key={`accordion-${i}`}
                            isOpen={!!openSections[label]}
                            label={label}
                            onClick={this.handleAccordionClick}>
                            {grandChildren}
                        </AccordionSection>
                    );
                })}
            </div>
        );
    }
}

export default injectSheet(styles)(Accordion);